import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { OpportunitiesListComponent } from '@pages/opportunities/opportunities-list/opportunities-list.component';
import { FilterStateService } from '@services/filter-state.service';
import { IAdditionalFilterVisibilityConfig } from '@shared/additional-filters/additional-filters.config';
import { OpportunitiesFiltersComponent } from '@shared/opportunities-filters/opportunities-filters.component';
import {
    IAdditionalFiltersOpportunities,
    IMainFiltersOpportunities,
    OPPORTUNITIES_ACCOUNT_FILTER_KEY
} from '@shared/opportunities-filters/opportunity-filters.config';

@Component({
    selector: 'app-accounts-single-opportunities',
    templateUrl: './accounts-single-opportunities.component.html',
    styleUrls: ['./accounts-single-opportunities.component.scss'],
    imports: [OpportunitiesFiltersComponent, OpportunitiesListComponent],
    changeDetection: ChangeDetectionStrategy.Eager,
    providers: [
        {
            provide: FilterStateService,
            useClass: FilterStateService<IMainFiltersOpportunities, IAdditionalFiltersOpportunities>
        }
    ]
})
export class AccountsSingleOpportunitiesComponent {
    readonly accountId = input<number>();

    readonly filtersKey = OPPORTUNITIES_ACCOUNT_FILTER_KEY;

    filtersVisibility: IAdditionalFilterVisibilityConfig = {
        dueDate: true,
        expectedBookingDate: true,
        account: false,
        company: true,
        companyRole: true,
        potentialValue: true,
        proposedGrossMargin: true,
        probability: true,
        department: true,
        salesperson: true,
        status: true,
        includeArchived: true
    };
}
